import { Component, ViewChild } from '@angular/core';
import { HeaderService } from '@app/core/services/header.service';
import { ODataService } from '@app/core/services/odata/odata.service';
import { SortParam } from '@app/core/constants/sort-param';
import { Observable } from 'rxjs';
import { ODataType } from '@app/core/services/odata/types/odata-type';
import { TableComponent } from '@shared/components/table/table.component';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { dashboardColumns } from '@shared/columns/dashboard.columns';
import { odataTableConfig } from '@app/core/config/odata-table-config';
import { ModalService } from '@app/core/services/modal.service';
import { Trash } from 'lucide-angular';
import {
  DashboardQueryManuallyHandledComponent
} from '@shared/modals/dashboard/query/dashboard-query-manually-handled/dashboard-query-manually-handled.component';

@Component({
  selector: 'app-dashboard-deviating-meters',
  imports: [
    TableComponent
  ],
  templateUrl: './dashboard-deviating-meters-component.html',
  styleUrl: './dashboard-deviating-meters-component.css'
})
export class DashboardDeviatingMetersComponent {
  @ViewChild('table', { static: false }) public table?: TableComponent<any>;

  public selectedElements: any[] = [];

  public tableConfig: TableConfig<any> = {
    id: 'table-dashboard-meters-deviating',
    columns: dashboardColumns,
    activeColumns: ['meterReadingTs', 'meteringPointIdentification', 'connectionPointIdentification', 'mainMeterNumber', 'verificationMeterNumber', 'quadrant', 'meterReadingValue', 'verificationMeterReadingValue', 'relativeDeviation', 'absoluteDeviation'],
    ...odataTableConfig,
    selectable: true,
    selectableType: 'multiple',
    fetchOnLoad: true,
    serviceCallback: (pageSize: number, page: number, order?: SortParam) => this.search(pageSize, page, order),
  }

  constructor(
    private readonly headerService: HeaderService,
    private readonly oDataService: ODataService,
    private readonly modalService: ModalService,
  ) {
    this.headerService.setTitle('dashboard.query.deviatingmeters.title');
    this.headerService.setActions([
      {
        id: 'remove',
        title: 'dashboard.remove.title',
        icon: Trash,
        callback: () => this.openRemoveModal(),
        disabled: () => this.selectedElements.length === 0,
      }
    ]);
  }

  public search(pageSize: number, page: number, sort?: SortParam): Observable<any> {
    return this.oDataService.dmc.getPaginated(ODataType.deviatingMeters, { pageSize, page, sort });
  }

  public openRemoveModal(): void {
    this.modalService.show({
      component: DashboardQueryManuallyHandledComponent,
      title: 'dashboard.remove.title',
      type: 'middle',
      actions: [
        { type: 'primary', label: 'common.yes', method: 'submit' },
        { type: 'secondary', label: 'common.no', closeOnClick: true },
      ],
      params: {
        elements: this.selectedElements,
        actionType: 'deviatingMeters',
      }
    }).subscribe(() => {
      this.table?.search();
    });
  }
}
